import React, { createContext, useState, useEffect, useContext } from "react";
import api, { clearCache } from "../services/api";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState("email");

  useEffect(() => {
    const storedToken = localStorage.getItem("gutful_token");

    const checkUser = async () => {
      if (storedToken) {
        try {
          // Set token in header for this request (if not already set globally)
          // Assuming api instance handles this or we manually add it
          const response = await api.get("/auth/me", {
            headers: { Authorization: `Bearer ${storedToken}` },
          });
          if (response.data.success) {
            setUser(response.data.user);
            setToken(storedToken);
          } else {
            logout();
          }
        } catch (error) {
          console.error("Session verification failed:", error);
          logout();
        }
      }
      setLoading(false);
    };

    if (storedToken) {
      checkUser();
    } else {
      setLoading(false);
    }
  }, []);

  const login = (userData, authToken) => {
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 30);

    localStorage.setItem("gutful_token", authToken);
    localStorage.setItem("gutful_user", JSON.stringify(userData));
    localStorage.setItem("gutful_auth_expiry", expiry.toISOString());

    setToken(authToken);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("gutful_token");
    localStorage.removeItem("gutful_user");
    localStorage.removeItem("gutful_auth_expiry");
    localStorage.removeItem("gutful_user_location");
    
    // Clear all cached data
    clearCache();

    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, step, setStep }}>
      {children}
    </AuthContext.Provider>
  );
};
